import { Button, Flex, Tooltip } from 'antd';
import { Link } from 'react-router-dom';
import { useTranslation } from 'translations/hooks';

import { usePermissions } from 'business/contextProviders/usePermissions';
import { useSegmentHistoryFilters } from 'business/quality-control/pages/segment-history/providers/filters';
import Routes from 'config/routes';
import { Quality_SegmentHistoryStatusEnum_Enum } from 'generated/graphql';

import { SegmentHistoryExportButtons } from './export-buttons';

export const SegmentHistoryHeader = ({
  onOpenBulkStatusModal,
}: {
  onOpenBulkStatusModal: () => void;
}) => {
  const { t } = useTranslation();

  const {
    isDataManager,
    modules: {
      QUALITY_SCAN: { isConstructionSiteManager },
    },
  } = usePermissions();

  const filters = useSegmentHistoryFilters();

  const isBulkStatusEnabled =
    filters.status.length === 1 &&
    (filters.status[0] === Quality_SegmentHistoryStatusEnum_Enum.Imported ||
      filters.site != null);

  return (
    <Flex gap={4}>
      {isDataManager || isConstructionSiteManager ? (
        <>
          <Link to={Routes.QualitySegmentImport}>
            <Button>{t('qualityControl.segmentHistory.cta.import')}</Button>
          </Link>
          <Tooltip
            title={t('qualityControl.segmentHistory.cta.bulkStatusTooltip')}
          >
            <span>
              <Button
                disabled={!isBulkStatusEnabled}
                onClick={onOpenBulkStatusModal}
              >
                {t('qualityControl.segmentHistory.cta.bulkStatus')}
              </Button>
            </span>
          </Tooltip>
        </>
      ) : null}
      <SegmentHistoryExportButtons />
    </Flex>
  );
};
